import { Controller } from 'stimulus';
import Macy from 'macy';

class MasonryController extends Controller {
  connect() {
    // eslint-disable-next-line no-new
    new Macy({
      container: this.element,
      columns: 1,
      mobileFirst: true,
      margin: {
        x: 15,
        y: 15,
      },
      breakAt: {
        576: 2,
        768: 3,
      },
    });
  }
}

MasonryController.targets = [
  //
];

export default MasonryController;
